import React from "react";
import { Container } from "@mui/material";
import { Column } from "../../KanbanComponents/Column";
import { ColumnType } from "./appointmentsConstants";
import { DragDropContext, DropResult } from "react-beautiful-dnd";
import { IAppointmentsDataType } from "../../../redux/reduxAppointments/appointmentsSlice";
import { updateAppointment } from "../../networkCalls";
import { responseObject, showToastType } from "../../utils";

export function AppointmentKanban({
  appointmentsData,
  columnOrdering,
  columnsData,
}: {
  appointmentsData: Array<IAppointmentsDataType>;
  columnOrdering: string[];
  columnsData: {
    [columnId: string]: ColumnType;
  };
}) {
  // const [columnOrderState, setcolumnOrderState] = useState<string[]>(
  //   columnOrder
  // );
  // const [columnsData, setColumnsData] = useState<{
  //   [columnId: string]: ColumnType;
  // }>(columns);
  async function onDragEnd(result: DropResult) {
    const { destination, source, draggableId } = result;
    if (!destination) {
      // NO Change
      return;
    }
    if (destination.droppableId === source.droppableId) {
      // NO Change
      return;
    }

    // const dragFrom = source.droppableId;
    const dropTo = destination.droppableId;
    // custom logic for dragging
    const updatedAppointmentResponseObject: responseObject =
      await updateAppointment(
        {
          status: dropTo,
        },
        draggableId
      );
    const message = updatedAppointmentResponseObject["message"];
    const status = updatedAppointmentResponseObject["statusCode"];
    showToastType(message, status);
  }
  return (
    <DragDropContext onDragEnd={onDragEnd}>
      {/* <Container
        style={{
          // display: "flex"
          display: "grid",
          gridTemplateColumns: "1fr 1fr 1fr 1fr 1fr 1fr 1fr",
          gridGap: "10px",
        }}
      > */}
      <div className="grid grid-rows-0 grid-flow-col gap-4">
        {columnOrdering.map((columnId) => {
          const column = columnsData[columnId];

          const appointmentList = appointmentsData
            .filter((appointment) => {
              if (appointment.status === column.id) {
                return appointment;
              }
            })
            .sort(customSorting);

          return (
            <Column
              key={column.id}
              column={column}
              appointments={appointmentList}
            />
          );
        })}
      </div>
      {/* </Container> */}
    </DragDropContext>
  );
}

function customSorting(
  elementA: IAppointmentsDataType,
  elementB: IAppointmentsDataType
) {
  if (
    elementA.status === "HAS_APPOINTMENT" &&
    elementB.status === "HAS_APPOINTMENT"
  ) {
    if (elementA.startDateTime < elementB.startDateTime) {
      return -1;
    }
    if (elementA.startDateTime > elementA.startDateTime) {
      return 1;
    }
    return 0;
  } else {
    if (elementA.updatedAt < elementB.updatedAt) {
      return -1;
    }
    if (elementA.updatedAt > elementA.updatedAt) {
      return 1;
    }
    return 0;
  }
}
